import { GetManyResponse, GetOneResponse } from 'coreOld/types';
import { objectKeysSnakeCaseToCamelCase } from 'coreOld/utils';

export const mapRecordsFromServer = <T>(
  data: T[],
  recordsFiltered?: number,
  totals?: Record<string, any>
): GetManyResponse<T> => {
  return {
    records: objectKeysSnakeCaseToCamelCase(data),
    count: recordsFiltered,
    totals: objectKeysSnakeCaseToCamelCase(totals),
  };
};

export const mapRecordFromServer = <T>(data: T[]): GetOneResponse<T> => {
  if (data?.length === 0) {
    return {
      record: null,
    };
  }

  return {
    record: objectKeysSnakeCaseToCamelCase(data),
  };
};
